import React from 'react';
import PropTypes from 'prop-types';

/**
 * En-tête commun aux documents imprimés du Bureau.
 *
 * TROIS COLONNES, REPRISES DE L'OFFRE D'INDEMNISATION CIMA : titre français à
 * gauche, emblème au centre avec sa légende, titre anglais à droite, filet vert
 * de séparation et bandeau d'accent en haut.
 *
 * DEUX IMPLÉMENTATIONS À TENIR EN ACCORD, ET IL FAUT LE SAVOIR. L'offre CIMA est
 * construite en jsPDF (`drawPdfHeader` dans WorkflowOffre.js) : elle dessine des
 * rectangles et place du texte à des millimètres donnés. La quittance et l'ordre
 * de dépense sont du HTML sérialisé puis imprimé. Les deux technologies ne
 * partagent aucun code : cet en-tête REPRODUIT l'autre, il ne le réutilise pas.
 * Toute retouche de l'un doit être reportée sur l'autre, faute de quoi les
 * documents du même bureau divergeront.
 *
 * LE BUREAU N'EST PAS ÉCRIT EN DUR. `bureau` désigne celui qui délivre le
 * document : figer « Togo » ferait sortir la pièce au nom du Togo le jour où un
 * autre bureau l'édite.
 */
export default function EnteteDocumentBncb({ bureau, logo, mentionDroite }) {
    const raisonSociale = bureau?.raisonSociale || 'BUREAU NATIONAL TOGOLAIS';

    return (
        <div className="bncb-entete">
            <div className="bncb-entete-accent" />
            <div className="bncb-entete-grille">
                <div className="bncb-entete-col">
                    <div className="bncb-entete-titre">{raisonSociale}</div>
                    <div className="bncb-entete-titre">CARTE BRUNE CEDEAO</div>
                </div>

                <div className="bncb-entete-col bncb-entete-col--centre">
                    {logo && <img src={logo} alt="" className="bncb-entete-logo" />}
                    <div className="bncb-entete-legende">Carte Brune CEDEAO</div>
                </div>

                <div className="bncb-entete-col">
                    <div className="bncb-entete-titre">{raisonSociale}</div>
                    <div className="bncb-entete-titre">ECOWAS BROWN CARD</div>
                </div>
            </div>
            {/* Mention libre alignée à droite sous le filet : la date de règlement
                pour la quittance, le numéro d'ordre pour l'ordre de dépense. Elle
                vit SOUS le filet et non dans la grille, pour que les trois
                colonnes gardent leur symétrie quelle que soit sa longueur. */}
            {mentionDroite && (
                <div className="bncb-entete-mention">{mentionDroite}</div>
            )}
        </div>
    );
}

EnteteDocumentBncb.propTypes = {
    bureau: PropTypes.object,
    logo: PropTypes.string,
    mentionDroite: PropTypes.node,
};
